import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    const closeMenu = () => setIsMenuOpen(false);

    return (
        <header className="bg-blue-900 text-white p-4 sticky top-0 z-10 shadow-md">
            <nav className="container mx-auto flex justify-between items-center">
                <Link to="/" className="flex items-center space-x-2">
                    <img src="/IITHLogo.png" alt="IITH Logo" className="h-10" />
                    <span className="font-bold text-xl">Kritik Agarwal</span>
                </Link>

                {/* Desktop Nav */}
                <div className="hidden md:flex space-x-6 text-sm font-medium">
                    <Link to="/" className="hover:underline">Home</Link>
                    <Link to="/cv" className="hover:underline">CV/Resume</Link>
                    <Link to="/blog" className="hover:underline">Blog</Link>
                    <Link to="/blog/mtechcse@iith" className="hover:underline">M.Tech CSE@IITH</Link>
                    <Link to="/contact" className="hover:underline">Contact Me</Link>
                </div>

                {/* Hamburger */}
                <button
                    onClick={toggleMenu}
                    aria-label="Toggle menu"
                    className="md:hidden focus:outline-none"
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                    </svg>
                </button>
            </nav>

            {/* Mobile Nav */}
            {isMenuOpen && (
                <div className="md:hidden bg-blue-800 px-4 pb-4 text-sm font-medium">
                    <Link to="/" className="block py-2 hover:underline" onClick={closeMenu}>Home</Link>
                    <Link to="/cv" className="block py-2 hover:underline" onClick={closeMenu}>CV/Resume</Link>
                    <Link to="/blog" className="block py-2 hover:underline" onClick={closeMenu}>Blog</Link>
                    <Link to="/blog/mtechcse@iith" className="block py-2 hover:underline" onClick={closeMenu}>M.Tech CSE@IITH</Link>
                    <Link to="/contact" className="block py-2 hover:underline" onClick={closeMenu}>Contact Me</Link>
                </div>
            )}
        </header>
    );
}
